import { withLDConsumer } from 'launchdarkly-react-client-sdk';
import { arrayOf, bool, func, number, shape, string } from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { selectProductDetail } from '../../../../modules/growth';
import Product from '../Product/Product';
import * as styles from './ProductContainer.module.css';

const ProductContainer = ({
  exploreDisplay = false,
  products,
  open,
  viewAll,
  initialDisplayAmount = 0,
  isMobile,
  isSelect = false,
  hasBeenAssigned,
  isBoost = false,
  winter2020MysteryChoice = false,
  selectProductDetail,
}) => {
  return (
    <div className={styles.container}>
      {products.map((item, index) => {
        const hideItem = !viewAll && index > initialDisplayAmount - 1;

        if (item) {
          return (
            <div
              key={String(item.id) + index}
              style={{ display: hideItem ? 'none' : 'inherit' }}
              className={styles.productContainer}
            >
              <Product
                exploreDisplay={exploreDisplay}
                {...item}
                open={open}
                isSelect={isSelect}
                hasBeenAssigned={hasBeenAssigned}
                isBoost={isBoost}
                winter2020MysteryChoice={winter2020MysteryChoice}
                selectProductDetail={selectProductDetail}
              />
              {isMobile && index < products.length - 1 && <div className={styles.horRule} />}
            </div>
          );
        }
      })}
    </div>
  );
};

ProductContainer.propTypes = {
  exploreDisplay: bool,
  products: arrayOf(
    shape({
      productId: string.isRequired,
      cadenceType: string,
    }),
  ).isRequired,
  open: bool.isRequired,
  viewAll: bool.isRequired,
  initialDisplayAmount: number,
  isMobile: bool.isRequired,
  isSelect: bool,
  hasBeenAssigned: bool,
  isBoost: bool,
  winter2020MysteryChoice: bool,
  selectProductDetail: func,
};

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      selectProductDetail,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(withLDConsumer()(ProductContainer));
